// extracted by mini-css-extract-plugin
export default {"bodyCards":"style_bodyCards__nVypo","card":"style_card__C1oKh","image":"style_image__bC8gE","label":"style_label__CKPFE","selected":"style_selected__wP2wR"};